import React                              from 'react';
		import { useEffect, useRef, useState    } from "react";
		import { ErrorBoundary                  } from "react-error-boundary";
		import {
			Routes,
			Route,
			Link,
			useNavigate,
		}                                         from "react-router-dom";

		import {
			motion,
			AnimatePresence
		} 						  				  from "framer-motion";	

		import {
			fallbackRender,
			add_sub,
			remove_subs
		}                                         from "../utils.jsx";
		import {COMP_REG}                         from "../comp_registry.js";
		import g_fn                               from '../g_fn';



		


		const AS    = g_fn.AS;
		

		// @req: keep reference to subs here and remove them on unmount or reload
		const SUB_ID = "bnode_ltmqc";
		const EN_BROKEN_COMP_LOGS = window.EN_BROKEN_COMP_LOGS || {};


		// local code - e.g sub components
		


		const comp_bnode_ltmqc = (props)=>{
			const INFO  = {"model_id":"fhmae","model_name":"question","op":"create_one","comp_id":"comp_bnode_ltmqc"};

			// Routes
			



			// FOR IS_MANY
			let idx = props.idx;   // also for protection from error when we might think is many but it's not
			let V = props.V || {}; // for protection from error


			// STATES
			const [rerender, set_rerender] = useState({});
const [M, set_M]     = useState(props.M || {})
const [PM, set_PM]     = useState(props.PM || [])
const [selected_M, set_selected_M]                         = useState(null)

			// REFS
			

			// EFFECTS
			
		useEffect(()=>{
			console.log("COMPONENT RERENDERED : ", JSON.stringify(M));
		},[rerender])
	

			useEffect(()=>{
				const deinit = init();

				return () => {
					if(deinit && typeof(deinit) === "function") deinit();
				}
			},[])
		

			useEffect(()=>{
				// console.log("OP CREATE ONE PROPS CHANGED : ", INFO.model_id, INFO.comp_id, props, relation);
				if(!relation || !INFO.model_id || !INFO.comp_id) return;
				if(props.PM && Array.isArray(props.PM) && props.PM.length) {
					const parent_M = props.PM[props.PM.length - 1];
					const parent_M_copy = JSON.parse(JSON.stringify(parent_M));
					delete parent_M_copy[':db/id'];
					const model_data = parent_M_copy[relation.prop_name];
					if(!model_data) return;
					delete model_data[':db/id'];
					if(Object.keys(model_data).length === 0) return console.warn("NO RELATION DATA FOUND FROM PARENT MODEL");
					if(Object.keys(model_data).length === 1 && model_data.id) {
						(async () => {
							const r = await AS.GSTORE.get_one_entity(INFO.model_id, model_data.id);
							if(r) {
								// if we are getting from GSTORE, make sure to make a copy as the changes in form can alter the object because of reference.
								const r_copy = JSON.parse(JSON.stringify(r));
								set_M(r_copy);
							}
						})();
					}
					if(Object.keys(model_data).length > 1) {
						set_M(model_data);
					}
				}
			},[props])
		

			useEffect(()=>{
				if(!M) return;
				if(!INFO.model_id || !INFO.comp_id) return;
				const model_id = INFO.model_id;
				const comp_id = INFO.comp_id;

				const idx = props.idx || props.IDX;

				const subscribe_id = idx || 0;

				const model = g_fn.get_model(model_id);
				if(!model) return;
				const id_prop = model.props.find(p=>p.name === 'id');
				if(model.name.toLowerCase() === 'user' && id_prop && id_prop.type === 'user_id') {
					if(M.email) {
						(async () => {
							const user_id = await g_fn.generate_user_id_by_email(M);
							// loop breaker for user_id in the following line, to be fixed properly
							if(user_id === M.id) return;
							if(user_id) {
								// not storing id in draft, if the same component is mapped, id will also be same for different entities
								set_M(PM => {
									PM.id = user_id;

									console.log("SETTING REACT STATE : ", PM);
									AS.GSTORE.update_draft(model_id, comp_id, subscribe_id, PM);
									return PM;
								});
								return;
							}
						})();
						return;
					}
				}
				AS.GSTORE.update_draft(model_id, comp_id, subscribe_id, M);
			},[M])
		
useEffect(()=>{
			if(EN_BROKEN_COMP_LOGS.MODEL_EFFECT){
				const MI = INFO.model_name.toUpperCase() + " : " + INFO.op.toUpperCase();
				console.log("MODEL CHANGED : " + MI + "   => ", "model", M, " props", props);
			}
		}, [M])

		useEffect(()=>{

			if(!INFO.model_id) return;

			if(query) INFO.query = query; // fall back to query if there is no selected entity for the model id;
			const id = g_fn.get_selected_entity_id(props, INFO);
			if(!id) {
				return console.warn("NO ID FOUND TO UPDATE ENTITY");
			}

			(async () => {
				const r = await AS.GSTORE.get_one_entity(INFO.model_id, id);
				console.log("GSTORE GET ONE ENTITY : ", r);
				if(r) set_selected_M(r);
			})();

			const sub = AS.GSTORE.subscribe_selected_entities(INFO.model_id, (e) => {
				const id = g_fn.get_selected_entity_id(props, INFO);
				if(!id) return console.warn("NO ID FOUND TO UPDATE ENTITY IN SUBSCRIPTION");
				(async () => {
					const r = await AS.GSTORE.get_one_entity(INFO.model_id, id);
					console.log("GSTORE GET ONE ENTITY IN SUBSCRIPTION : ", r, INFO.model_id, INFO.comp_id);
					if(r) set_selected_M(r);
				})();
			});

			// On set in GSTORE set state
			const sub2 = AS.GSTORE.subscribe((e)=>{
				const {type, model_id, eid, data} = e;
				 if(!data || !data.id) return;
				 if(type !== 'set') return;
				 if(model_id !== INFO.model_id) return;
				 set_M(M=>{
				   if(eid !== M.id) return M;
				   return data;
				 })
			 });

			return () => {
				sub.unsubscribe();
				sub2.unsubscribe();
			}
		},[])
	

			// FUNCTIONS
			
			const init = () => {

				if(!INFO.model_id || !INFO.comp_id) return;

				const model_id = INFO.model_id;
				const comp_id = INFO.comp_id;

				const subs = [];

				const id = g_fn.get_ulid();

				const idx = props.idx || props.IDX;

				const subscribe_id = idx || 0;

				subs.push(AS.GSTORE.subscribe_draft(model_id, comp_id, subscribe_id, (e)=>{

					console.log("SUBSCRIBE DRAFT : ", e, comp_id, props.idx, props.IDX, subscribe_id);

					if(e.data === null) {
						set_M(M => {
							for(let [k,v] of Object.entries(M)){
								if(k === "id") continue;
								delete M[k];
							}
						});
						return M;
					}

					if(e.data) {
						console.log("DRAFT DATA : ", e.data);
						const D = e.data;
						set_rerender({}); // to re-render
						set_M(M => {
							console.log("DRAFT IS SAME AS M : ", D === M, D, M);
							if(D === M) {
								return D; // same object
							}
							if((D?.id) !== M.id) {
								console.log("NOT SETTING DATA FROM A DIFFERENT FORM : ", D, M);
								return M; // ids are not equal which means data from a different form
							}
							return D;
						});
					}
				}));


				subs.push(AS.GSTORE.subscribe_message(model_id, (e) => {

					if(e.eid && e.message !== "CREATED") return;

					set_M(M => {
						return {id : g_fn.get_ulid()};
					});

					if(!relation) return;

					// if relation exists, update the parent model draft

					const rel_eid = props.id || null;
					console.log("RELATION ENTITY ID : ", rel_eid);

					console.log("RELATION : ", relation);
					const rel_mid = relation.model_id;
					const rel_cid = relation.comp_id || props.INFO?.comp_id;
					const updates = {[relation.prop_name] : e.data};
					AS.GSTORE.update_draft(rel_mid, rel_cid, subscribe_id, updates);
				}));

				// one time setup
				set_M(M => {
					const model = g_fn.get_model(model_id);
					let draft = AS.GSTORE.get_draft(model_id, comp_id, subscribe_id);
					if(!draft) {
						draft = {};
					}

					// drafts id can be same if the same component is mapped, so initialising new id every time
					if(M) return {...M, ...draft, id};

					return draft;
				});

				return () => {
					subs.forEach(s=>s.unsubscribe());
				}
			}
		


			// STATEMENTS
			
		INFO.set_M          = set_M;
		INFO.on_created     = props.on_created  || props.INFO?.on_created;
		INFO.on_selected    = props.on_selected || props.INFO?.on_selected;
		const relation		= {"model_id":"yvjbe","prop_name":"questions","comp_id":"comp_bnode_l1z1x"};
		const query			=	null;
	



			// CONDITIONALS ATTRS
			const COND_ATTRS = {};
			
				COND_ATTRS["bnode_wh91n"] = COND_ATTRS["bnode_wh91n"] || {};
			

				COND_ATTRS["bnode_fujjt"] = COND_ATTRS["bnode_fujjt"] || {};
			

				COND_ATTRS["bnode_venhp"] = COND_ATTRS["bnode_venhp"] || {};
			

				COND_ATTRS["bnode_wwh4p"] = COND_ATTRS["bnode_wwh4p"] || {};
			

				COND_ATTRS["bnode_qwkpp"] = COND_ATTRS["bnode_qwkpp"] || {};
			

				COND_ATTRS["bnode_v5p3b"] = COND_ATTRS["bnode_v5p3b"] || {};
			

				COND_ATTRS["bnode_50884"] = COND_ATTRS["bnode_50884"] || {};
			

				COND_ATTRS["bnode_afgu6"] = COND_ATTRS["bnode_afgu6"] || {};
			

				COND_ATTRS["bnode_wrmua"] = COND_ATTRS["bnode_wrmua"] || {};
			

				COND_ATTRS["bnode_i2k3l"] = COND_ATTRS["bnode_i2k3l"] || {};
			

				COND_ATTRS["bnode_fw7dr"] = COND_ATTRS["bnode_fw7dr"] || {};
			

				COND_ATTRS["bnode_fft4m"] = COND_ATTRS["bnode_fft4m"] || {};
			

				COND_ATTRS["bnode_kz3o1"] = COND_ATTRS["bnode_kz3o1"] || {};
			

				COND_ATTRS["bnode_rm6p0"] = COND_ATTRS["bnode_rm6p0"] || {};
			

				COND_ATTRS["bnode_x8syb"] = COND_ATTRS["bnode_x8syb"] || {};
			

				COND_ATTRS["bnode_dnxuj"] = COND_ATTRS["bnode_dnxuj"] || {};
			

				COND_ATTRS["bnode_29v9a"] = COND_ATTRS["bnode_29v9a"] || {};
			

				COND_ATTRS["bnode_jq3cm"] = COND_ATTRS["bnode_jq3cm"] || {};
			

				COND_ATTRS["bnode_oi554"] = COND_ATTRS["bnode_oi554"] || {};
			

				COND_ATTRS["bnode_bgvy2"] = COND_ATTRS["bnode_bgvy2"] || {};
			

				COND_ATTRS["bnode_92rme"] = COND_ATTRS["bnode_92rme"] || {};
			

				COND_ATTRS["bnode_r46mu"] = COND_ATTRS["bnode_r46mu"] || {};
			

				COND_ATTRS["bnode_mcdjp"] = COND_ATTRS["bnode_mcdjp"] || {};
			

				COND_ATTRS["bnode_68jlq"] = COND_ATTRS["bnode_68jlq"] || {};
			

				COND_ATTRS["bnode_5go2p"] = COND_ATTRS["bnode_5go2p"] || {};
			

				COND_ATTRS["bnode_0ei6v"] = COND_ATTRS["bnode_0ei6v"] || {};
			

				COND_ATTRS["bnode_vs1x4"] = COND_ATTRS["bnode_vs1x4"] || {};
			

				COND_ATTRS["bnode_w34eh"] = COND_ATTRS["bnode_w34eh"] || {};
			

				COND_ATTRS["bnode_w140g"] = COND_ATTRS["bnode_w140g"] || {};
			

				COND_ATTRS["bnode_3ozrq"] = COND_ATTRS["bnode_3ozrq"] || {};
			

				COND_ATTRS["bnode_1rmde"] = COND_ATTRS["bnode_1rmde"] || {};
			

				COND_ATTRS["bnode_07ew0"] = COND_ATTRS["bnode_07ew0"] || {};
			

				COND_ATTRS["bnode_psox1"] = COND_ATTRS["bnode_psox1"] || {};
			

				COND_ATTRS["bnode_mmbcn"] = COND_ATTRS["bnode_mmbcn"] || {};
			

				COND_ATTRS["bnode_p21ss"] = COND_ATTRS["bnode_p21ss"] || {};
			

				COND_ATTRS["bnode_ky1xc"] = COND_ATTRS["bnode_ky1xc"] || {};
			

				COND_ATTRS["bnode_r13rw"] = COND_ATTRS["bnode_r13rw"] || {};
			

				COND_ATTRS["bnode_tthgg"] = COND_ATTRS["bnode_tthgg"] || {};
			

				COND_ATTRS["bnode_9kiz4"] = COND_ATTRS["bnode_9kiz4"] || {};
			

				COND_ATTRS["bnode_0o00f"] = COND_ATTRS["bnode_0o00f"] || {};
			

				COND_ATTRS["bnode_cgryp"] = COND_ATTRS["bnode_cgryp"] || {};
			

				COND_ATTRS["bnode_r50qy"] = COND_ATTRS["bnode_r50qy"] || {};
			

				COND_ATTRS["bnode_jvqs1"] = COND_ATTRS["bnode_jvqs1"] || {};
			

				COND_ATTRS["bnode_59kj8"] = COND_ATTRS["bnode_59kj8"] || {};
			

				COND_ATTRS["bnode_1o1kb"] = COND_ATTRS["bnode_1o1kb"] || {};
			

				COND_ATTRS["bnode_1hr7y"] = COND_ATTRS["bnode_1hr7y"] || {};
			

				COND_ATTRS["bnode_ks59b"] = COND_ATTRS["bnode_ks59b"] || {};
			

				COND_ATTRS["bnode_norxs"] = COND_ATTRS["bnode_norxs"] || {};
			

				COND_ATTRS["bnode_kvx2t"] = COND_ATTRS["bnode_kvx2t"] || {};
			

				COND_ATTRS["bnode_70vfq"] = COND_ATTRS["bnode_70vfq"] || {};
			

				COND_ATTRS["bnode_kanwn"] = COND_ATTRS["bnode_kanwn"] || {};
			

				COND_ATTRS["bnode_l9c4h"] = COND_ATTRS["bnode_l9c4h"] || {};
			

				COND_ATTRS["bnode_chdfj"] = COND_ATTRS["bnode_chdfj"] || {};
			

				COND_ATTRS["bnode_8mmjv"] = COND_ATTRS["bnode_8mmjv"] || {};
			

				COND_ATTRS["bnode_cutfa"] = COND_ATTRS["bnode_cutfa"] || {};
			

				COND_ATTRS["bnode_for3e"] = COND_ATTRS["bnode_for3e"] || {};
			

				COND_ATTRS["bnode_6o75w"] = COND_ATTRS["bnode_6o75w"] || {};
			

				COND_ATTRS["bnode_4jmtx"] = COND_ATTRS["bnode_4jmtx"] || {};
			

				COND_ATTRS["bnode_g2nli"] = COND_ATTRS["bnode_g2nli"] || {};
			

				COND_ATTRS["bnode_o1g2v"] = COND_ATTRS["bnode_o1g2v"] || {};
			

				COND_ATTRS["bnode_zm60b"] = COND_ATTRS["bnode_zm60b"] || {};
			

				COND_ATTRS["bnode_5kd26"] = COND_ATTRS["bnode_5kd26"] || {};
			

				COND_ATTRS["bnode_9ct7o"] = COND_ATTRS["bnode_9ct7o"] || {};
			

				COND_ATTRS["bnode_rjmo9"] = COND_ATTRS["bnode_rjmo9"] || {};
			

				COND_ATTRS["bnode_qtdd9"] = COND_ATTRS["bnode_qtdd9"] || {};
			

				COND_ATTRS["bnode_jnyx1"] = COND_ATTRS["bnode_jnyx1"] || {};
			

				COND_ATTRS["bnode_rfk22"] = COND_ATTRS["bnode_rfk22"] || {};
			

				COND_ATTRS["bnode_n76b0"] = COND_ATTRS["bnode_n76b0"] || {};
			

				COND_ATTRS["bnode_e0rit"] = COND_ATTRS["bnode_e0rit"] || {};
			

				COND_ATTRS["bnode_yo35h"] = COND_ATTRS["bnode_yo35h"] || {};
			

				COND_ATTRS["bnode_ry697"] = COND_ATTRS["bnode_ry697"] || {};
			

				COND_ATTRS["bnode_3blrd"] = COND_ATTRS["bnode_3blrd"] || {};
			

				COND_ATTRS["bnode_48jzn"] = COND_ATTRS["bnode_48jzn"] || {};
			

				COND_ATTRS["bnode_oyore"] = COND_ATTRS["bnode_oyore"] || {};
			

				COND_ATTRS["bnode_xgypd"] = COND_ATTRS["bnode_xgypd"] || {};
			

				COND_ATTRS["bnode_a0ve1"] = COND_ATTRS["bnode_a0ve1"] || {};
			

				COND_ATTRS["bnode_gp4ea"] = COND_ATTRS["bnode_gp4ea"] || {};
			

				COND_ATTRS["bnode_bd7t8"] = COND_ATTRS["bnode_bd7t8"] || {};
			

				COND_ATTRS["bnode_csyrs"] = COND_ATTRS["bnode_csyrs"] || {};
			

				COND_ATTRS["bnode_ksiqy"] = COND_ATTRS["bnode_ksiqy"] || {};
			

				COND_ATTRS["bnode_vh1ij"] = COND_ATTRS["bnode_vh1ij"] || {};
			

				COND_ATTRS["bnode_nmvhd"] = COND_ATTRS["bnode_nmvhd"] || {};
			

				COND_ATTRS["bnode_gyvxc"] = COND_ATTRS["bnode_gyvxc"] || {};
			

				COND_ATTRS["bnode_48pl0"] = COND_ATTRS["bnode_48pl0"] || {};
			

				COND_ATTRS["bnode_ltmqc"] = COND_ATTRS["bnode_ltmqc"] || {};
			


			// DYNAMIC REACT STATES
			const REACT_STATES = {};
REACT_STATES["M"] = {state: M, set_state: set_M};

		const AS_COMPONENTS = AS.components["comp_bnode_ltmqc"] || {};
		AS_COMPONENTS.REACT_STATES = REACT_STATES;
		AS.components["comp_bnode_ltmqc"] = AS_COMPONENTS;
	



			// MAPPED DATA
			const MAPPED_DATA = {};



			return (
				<ErrorBoundary fallbackRender={fallbackRender} onReset={(d) => {console.error(d)}}>
					
            <div data_id="bnode_ltmqc" name="question" op="create_one" className="w-full flex flex-col p-4 border rounded border-zinc-200 relative bg-white" id={"bnode_ltmqc" + (idx?"__"+idx:"")} onClick={(e)=>{
            g_fn.dev.emit_m(e, M, INFO)
        }} extra-attr >
                
            <div data_id="bnode_wh91n" name="title" className=" text-2xl font-medium text-gray-600 text-left pb-6" id={"bnode_wh91n" + (idx?"__"+idx:"")} extra-attr >
                
            CREATE QUESTION
        
            </div>
        

            <div data_id="bnode_vh1ij" name="question-data" className="flex flex-col gap-4" id={"bnode_vh1ij" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_jq3cm" className="new-div w-full flex items-center justify-center gap-4" id={"bnode_jq3cm" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_fw7dr" name="CONT-type" className="w-full" id={"bnode_fw7dr" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_i2k3l" id={"bnode_i2k3l" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_fujjt" className="block text-gray-700 text-sm font-medium mb-2 capitalize" id={"bnode_fujjt" + (idx?"__"+idx:"")} extra-attr >
                type
            </div>
        

            <div data_id="bnode_wrmua" name="type" className="flex flex-col  w-full gap-6 " id={"bnode_wrmua" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_afgu6" className="flex flex-row items-center justify-center w-full gap-4" id={"bnode_afgu6" + (idx?"__"+idx:"")} extra-attr >
                
            <select data_id="bnode_50884" name="type" placeholder="type" action="oninput-update-m" className="w-full border border-[#8A8A8A] bg-white p-2 rounded-[8px] placeholder:capitalize placeholder:text-[#222222]/30" id={"bnode_50884" + (idx?"__"+idx:"")} model_id="fhmae" onInput={(e)=>{g_fn.bro_on_input(e, INFO)}} extra-attr >
                
            <option data_id="bnode_venhp" selected="true" id={"bnode_venhp" + (idx?"__"+idx:"")} extra-attr >
                
            </option>
        

            <option data_id="bnode_wwh4p" value="MCQs" selected={M.type === 'MCQs'} id={"bnode_wwh4p" + (idx?"__"+idx:"")} extra-attr >
                MCQs
            </option>
        

            <option data_id="bnode_qwkpp" value="FITB" selected={M.type === 'FITB'} id={"bnode_qwkpp" + (idx?"__"+idx:"")} extra-attr >
                FITB
            </option>
        

            <option data_id="bnode_v5p3b" value="reorder" selected={M.type === 'reorder'} id={"bnode_v5p3b" + (idx?"__"+idx:"")} extra-attr >
                reorder
            </option>
        
            </select>
        
            </div>
        
            </div>
        
            </div>
        
            </div>
        

            <div data_id="bnode_29v9a" name="CONT-points" className="w-full" id={"bnode_29v9a" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_dnxuj" id={"bnode_dnxuj" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_fft4m" className="block text-gray-700 text-sm font-medium mb-2 capitalize" id={"bnode_fft4m" + (idx?"__"+idx:"")} extra-attr >
                points
            </div>
        

            <div data_id="bnode_x8syb" name="points" className="flex flex-col  w-full gap-6 " id={"bnode_x8syb" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_rm6p0" name="cont" className="flex flex-row items-center justify-center w-full gap-4" id={"bnode_rm6p0" + (idx?"__"+idx:"")} extra-attr >
                <input data_id="bnode_kz3o1" name="points" type="number" value={M.points} placeholder="points" action="oninput-update-m" className="w-full border border-[#8A8A8A] bg-white p-2 rounded-[8px] placeholder:capitalize placeholder:text-[#222222]/30" id={"bnode_kz3o1" + (idx?"__"+idx:"")} model_id="fhmae" onInput={(e)=>{g_fn.bro_on_input(e, INFO)}} extra-attr />
            </div>
        
            </div>
        
            </div>
        
            </div>
        
            </div>
        

            <div data_id="bnode_68jlq" name="CONT-question" className="w-full" id={"bnode_68jlq" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_mcdjp" id={"bnode_mcdjp" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_oi554" className="block text-black mb-2 capitalize text-base font-semibold font-['Open_Sans']" id={"bnode_oi554" + (idx?"__"+idx:"")} extra-attr >
                question
            </div>
        

            <div data_id="bnode_r46mu" name="question" className="flex flex-col  w-full gap-6 " id={"bnode_r46mu" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_92rme" name="cont" className="flex flex-row items-center justify-center w-full gap-4" id={"bnode_92rme" + (idx?"__"+idx:"")} extra-attr >
                <input data_id="bnode_bgvy2" name="question" type="text" value={M.question} placeholder="question" action="oninput-update-m" className="w-full border border-[#9CA3AF] bg-white p-5 rounded-[12px] text-sm placeholder:text-sm placeholder:capitalize placeholder:text-[#222222]/30" id={"bnode_bgvy2" + (idx?"__"+idx:"")} model_id="fhmae" onInput={(e)=>{g_fn.bro_on_input(e, INFO)}} extra-attr />
            </div>
        
            </div>
        
            </div>
        
            </div>
        

            <div data_id="bnode_psox1" name="CONT-answers" className="w-full flex flex-col gap-2" id={"bnode_psox1" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_5go2p" className="block text-gray-700 mb-2 capitalize text-base font-semibold font-['Open_Sans']" id={"bnode_5go2p" + (idx?"__"+idx:"")} extra-attr >
                answers
            </div>
        

                    {M && g_fn.safe_array(M.answers).map(
                        (V, idx)=> (
                            
            <div data_id="bnode_3ozrq" name="answers" className="flex w-full gap-6 flex-col" id={"bnode_3ozrq" + (idx?"__"+idx:"")} key={g_fn.get_key_from_meta(M, "answers", idx)} extra-attr >
                
            <div data_id="bnode_w140g" name="cont" className="flex flex-row items-center justify-center w-full gap-4" id={"bnode_w140g" + (idx?"__"+idx:"")} extra-attr >
                <input data_id="bnode_0ei6v" name="answers" b_idx={idx} type="text" value={V.v} placeholder="answers" action="oninput-update-m-idx" className="border border-[#9CA3AF] p-4 rounded-[12px] bg-white focus:outline-none w-full text-sm placeholder:text-sm placeholder:capitalize placeholder:text-[#222222]/30" id={"bnode_0ei6v" + (idx?"__"+idx:"")} model_id="fhmae" onInput={(e)=>{g_fn.bro_on_input_idx(e, INFO)}} extra-attr />

            <button data_id="bnode_w34eh" name="answers" b_idx={idx} action="delete-prop-item" className="bg-none text-rose-300 p-1.5 rounded-md hover:bg-rose-400 hover:text-white transition-all ease-in-out duration-150" id={"bnode_w34eh" + (idx?"__"+idx:"")} model_id="fhmae" onClick={(e)=>{

            

            if(window.BROKEN_DEV_VARS && window.BROKEN_DEV_VARS.IS_EDITING_MODE) return;
            e.preventDefault(); e.stopPropagation(); 
            
            const el = e.currentTarget; el.disabled = true; el.classList?.add('disabled', 'cursor-progress');
                g_fn.bro_delete_prop_item(e, INFO)
            el.disabled = false; el.classList?.remove('disabled', 'cursor-progress');
        }} extra-attr >
                
            <svg data_id="bnode_vs1x4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="trash-2" className="lucide lucide-trash-2" id={"bnode_vs1x4" + (idx?"__"+idx:"")} b_type="icon" extra-attr >
                
            <path data_id="" d="M3 6h18" extra-attr >
                
            </path>
        

            <path data_id="" d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" extra-attr >
                
            </path>
        

            <path data_id="" d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" extra-attr >
                
            </path>
        

            <line data_id="" x1="10" x2="10" y1="11" y2="17" extra-attr >
                
            </line>
        

            <line data_id="" x1="14" x2="14" y1="11" y2="17" extra-attr >
                
            </line>
        
            </svg>
        
            </button>
        
            </div>
        
            </div>
        
                        )
                    )}
                

            <button data_id="bnode_07ew0" type="text" action="add-prop-item" name="answers" className="w-10 h-10 flex justify-center items-center mx-auto border border-gray-100 bg-gray-200 hover:border-gray-200 text-gray-700 text-3xl rounded-lg " id={"bnode_07ew0" + (idx?"__"+idx:"")} model_id="fhmae" onClick={(e)=>{

            

            if(window.BROKEN_DEV_VARS && window.BROKEN_DEV_VARS.IS_EDITING_MODE) return;
            e.preventDefault(); e.stopPropagation(); 
            
            const el = e.currentTarget; el.disabled = true; el.classList?.add('disabled', 'cursor-progress');
                g_fn.bro_add_prop_item(e, INFO)
            el.disabled = false; el.classList?.remove('disabled', 'cursor-progress');
        }} extra-attr >
                
            <svg data_id="bnode_1rmde" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" id={"bnode_1rmde" + (idx?"__"+idx:"")} b_type="icon" extra-attr >
                
            <path data_id="" d="M5 12h14" extra-attr >
                
            </path>
        

            <path data_id="" d="M12 5v14" extra-attr >
                
            </path>
        
            </svg>
        
            </button>
        
            </div>
        
{ false && (<div data_id="bnode_9kiz4" name="CONT-time" className="w-full" id={"bnode_9kiz4" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_tthgg" id={"bnode_tthgg" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_mmbcn" className="block text-gray-700 text-sm font-medium mb-2 capitalize" id={"bnode_mmbcn" + (idx?"__"+idx:"")} extra-attr >
                time
            </div>
        

            <div data_id="bnode_r13rw" name="time" className="flex flex-col  w-full gap-6 " id={"bnode_r13rw" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_ky1xc" name="cont" className="flex flex-row items-center justify-center w-full gap-4" id={"bnode_ky1xc" + (idx?"__"+idx:"")} extra-attr >
                <input data_id="bnode_p21ss" name="time" type="number" value={M.time} placeholder="time" action="oninput-update-m" className="border border-[--neutral-100] hover:border-[--neutral-50] bg-[--shades-800] px-4 py-1.5 rounded focus:border-[var(--primary-400)] focus:border-1 focus:bg-white focus:outline-none w-full text-sm placeholder:text-sm placeholder:capitalize placeholder:text-[#222222]/30 noscroll" id={"bnode_p21ss" + (idx?"__"+idx:"")} model_id="fhmae" onInput={(e)=>{g_fn.bro_on_input(e, INFO)}} extra-attr />
            </div>
        
            </div>
        
            </div>
        
            </div>) }

            <div data_id="bnode_norxs" name="CONT-tags" className="w-full flex flex-col gap-2" id={"bnode_norxs" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_0o00f" className="block text-gray-700 text-sm font-medium mb-2 capitalize" id={"bnode_0o00f" + (idx?"__"+idx:"")} extra-attr >
                tags
            </div>
        

                    {M && g_fn.safe_array(M.tags).map(
                        (V, idx)=> (
                            
            <div data_id="bnode_1o1kb" name="tags" className="flex flex-col  w-full gap-6 " id={"bnode_1o1kb" + (idx?"__"+idx:"")} key={g_fn.get_key_from_meta(M, "tags", idx)} extra-attr >
                
            <div data_id="bnode_59kj8" name="cont" className="flex flex-row items-center justify-center w-full gap-4" id={"bnode_59kj8" + (idx?"__"+idx:"")} extra-attr >
                <input data_id="bnode_cgryp" name="tags" b_idx={idx} type="text" value={V.v} placeholder="tags" action="oninput-update-m-idx" className="border border-[--neutral-100] hover:border-[--neutral-50] bg-[--shades-800] px-4 py-1.5 rounded focus:border-[var(--primary-400)] focus:border-1 focus:bg-white focus:outline-none w-full text-sm placeholder:text-sm placeholder:capitalize placeholder:text-[#222222]/30 " id={"bnode_cgryp" + (idx?"__"+idx:"")} model_id="fhmae" onInput={(e)=>{g_fn.bro_on_input_idx(e, INFO)}} extra-attr />

            <button data_id="bnode_jvqs1" name="tags" b_idx={idx} action="delete-prop-item" className="bg-none text-rose-300 p-1.5 rounded-md hover:bg-rose-400 hover:text-white transition-all ease-in-out duration-150" id={"bnode_jvqs1" + (idx?"__"+idx:"")} model_id="fhmae" onClick={(e)=>{

            

            if(window.BROKEN_DEV_VARS && window.BROKEN_DEV_VARS.IS_EDITING_MODE) return;
            e.preventDefault(); e.stopPropagation(); 
            
            const el = e.currentTarget; el.disabled = true; el.classList?.add('disabled', 'cursor-progress');
                g_fn.bro_delete_prop_item(e, INFO)
            el.disabled = false; el.classList?.remove('disabled', 'cursor-progress');
        }} extra-attr >
                
            <svg data_id="bnode_r50qy" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" id={"bnode_r50qy" + (idx?"__"+idx:"")} b_type="icon" extra-attr >
                
            <path data_id="" d="M18 6 6 18" extra-attr >
                
            </path>
        

            <path data_id="" d="m6 6 12 12" extra-attr >
                
            </path>
        
            </svg>
        
            </button>
        
            </div>
        
            </div>
        
                        )
                    )}
                

            <button data_id="bnode_ks59b" type="text" action="add-prop-item" name="tags" className="w-10 h-10 flex justify-center items-center mx-auto border border-gray-100 bg-gray-200 hover:border-gray-200 text-gray-700 text-3xl rounded-lg " id={"bnode_ks59b" + (idx?"__"+idx:"")} model_id="fhmae" onClick={(e)=>{

            

            if(window.BROKEN_DEV_VARS && window.BROKEN_DEV_VARS.IS_EDITING_MODE) return;
            e.preventDefault(); e.stopPropagation(); 
            
            const el = e.currentTarget; el.disabled = true; el.classList?.add('disabled', 'cursor-progress');
                g_fn.bro_add_prop_item(e, INFO)
            el.disabled = false; el.classList?.remove('disabled', 'cursor-progress');
        }} extra-attr >
                
            <svg data_id="bnode_1hr7y" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" id={"bnode_1hr7y" + (idx?"__"+idx:"")} b_type="icon" extra-attr >
                
            <path data_id="" d="M5 12h14" extra-attr >
                
            </path>
        

            <path data_id="" d="M12 5v14" extra-attr >
                
            </path>
        
            </svg>
        
            </button>
        
            </div>
        
{ false && (<div data_id="bnode_rjmo9" name="CONT-images" className="w-full flex flex-col gap-2" id={"bnode_rjmo9" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_kvx2t" className="block text-gray-700 text-sm font-medium mb-2 capitalize" id={"bnode_kvx2t" + (idx?"__"+idx:"")} extra-attr >
                images
            </div>
        

                    {M && g_fn.safe_array(M.images).map(
                        (V, idx)=> (
                            
            <div data_id="bnode_zm60b" name="images" className="flex flex-col  w-full gap-6 " id={"bnode_zm60b" + (idx?"__"+idx:"")} key={g_fn.get_key_from_meta(M, "images", idx)} extra-attr >
                
            <div data_id="bnode_o1g2v" name="cont" className="relative w-full flex flex-col md:flex-row items-center justify-center gap-4" id={"bnode_o1g2v" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_70vfq" name="image" style={{backgroundImage:`url("${V?.v?.url}")`}} className="w-32 h-32  flex flex-shrink-0 bg-no-repeat bg-gray-200 bg-center bg-cover rounded-md" id={"bnode_70vfq" + (idx?"__"+idx:"")} extra-attr >
                
            </div>
        

            <div data_id="bnode_6o75w" className="flex flex-col items-center" id={"bnode_6o75w" + (idx?"__"+idx:"")} extra-attr >
                <input data_id="bnode_kanwn" multiple="true" name="images" b_idx={idx} type="file" placeholder="images" action="oninput-update-m-file-idx" className="block w-full text-sm text-[var(--neutral-500)] file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-[var(--primary-100)] file:text-[var(--neutral-50)] hover:file:bg-[var(--primary-100)] p-1 rounded-full bg-[var(--neutral-100)] w-fit " id={"bnode_kanwn" + (idx?"__"+idx:"")} model_id="fhmae" onInput={(e)=>{g_fn.bro_on_input_file_idx(e, INFO)}} extra-attr />

            <div data_id="bnode_l9c4h" className="text-gray-400 w-fit px-2 text-center" id={"bnode_l9c4h" + (idx?"__"+idx:"")} extra-attr >
                or
            </div>
        

            <div data_id="bnode_for3e" className="relative w-full md:w-fit" id={"bnode_for3e" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_8mmjv" className="absolute left-2 top-1/2 -translate-y-1/2" id={"bnode_8mmjv" + (idx?"__"+idx:"")} extra-attr >
                
            <svg data_id="bnode_chdfj" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" id={"bnode_chdfj" + (idx?"__"+idx:"")} b_type="icon" extra-attr >
                
            <path data_id="" d="M10.0002 13.7031C10.4297 14.2772 10.9776 14.7523 11.6067 15.096C12.2359 15.4398 12.9317 15.6442 13.6468 15.6954C14.362 15.7466 15.0798 15.6435 15.7515 15.3929C16.4233 15.1423 17.0333 14.7502 17.5402 14.2431L20.5402 11.2431C21.451 10.3001 21.955 9.03707 21.9436 7.72608C21.9322 6.4151 21.4063 5.16104 20.4793 4.234C19.5523 3.30696 18.2982 2.78111 16.9872 2.76972C15.6762 2.75833 14.4132 3.2623 13.4702 4.17309L11.7502 5.88309M14.0002 11.7031C13.5707 11.129 13.0228 10.6539 12.3936 10.3102C11.7645 9.96639 11.0687 9.76197 10.3535 9.71076C9.63841 9.65954 8.92061 9.76272 8.24885 10.0133C7.5771 10.2639 6.96709 10.656 6.4602 11.1631L3.4602 14.1631C2.54941 15.1061 2.04544 16.3691 2.05683 17.6801C2.06822 18.9911 2.59407 20.2451 3.52111 21.1722C4.44815 22.0992 5.70221 22.6251 7.01319 22.6365C8.32418 22.6479 9.58719 22.1439 10.5302 21.2331L12.2402 19.5231" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" extra-attr >
                
            </path>
        
            </svg>
        
            </div>
        
<input data_id="bnode_cutfa" name="images" b_idx={idx} className="border border-[--neutral-100] hover:border-[--neutral-50] bg-[--shades-800] px-4 py-1.5 rounded focus:border-[var(--primary-400)] focus:border-1 focus:bg-white focus:outline-none w-full text-sm placeholder:text-sm placeholder:capitalize placeholder:text-[#222222]/30 pl-9 " b_type="image" type="text" placeholder="Paste image url" action="oninput-update-m-idx" id={"bnode_cutfa" + (idx?"__"+idx:"")} model_id="fhmae" onInput={(e)=>{g_fn.bro_on_input_idx(e, INFO)}} extra-attr />
            </div>
        
            </div>
        

            <button data_id="bnode_g2nli" name="images" b_idx={idx} action="delete-prop-item" className="bg-none text-rose-300 p-1.5 rounded-md hover:bg-rose-400 hover:text-white transition-all ease-in-out duration-150 absolute top-1.5 md:my-auto md:top-auto right-1.5  " id={"bnode_g2nli" + (idx?"__"+idx:"")} model_id="fhmae" onClick={(e)=>{

            

            if(window.BROKEN_DEV_VARS && window.BROKEN_DEV_VARS.IS_EDITING_MODE) return;
            e.preventDefault(); e.stopPropagation(); 
            
            const el = e.currentTarget; el.disabled = true; el.classList?.add('disabled', 'cursor-progress');
                g_fn.bro_delete_prop_item(e, INFO)
            el.disabled = false; el.classList?.remove('disabled', 'cursor-progress');
        }} extra-attr >
                
            <svg data_id="bnode_4jmtx" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" id={"bnode_4jmtx" + (idx?"__"+idx:"")} b_type="icon" extra-attr >
                
            <path data_id="" d="M18 6 6 18" extra-attr >
                
            </path>
        

            <path data_id="" d="m6 6 12 12" extra-attr >
                
            </path>
        
            </svg>
        
            </button>
        
            </div>
        
            </div>
        
                        )
                    )}
                

            <button data_id="bnode_9ct7o" type="image" action="add-prop-item" name="images" className="w-10 h-10 flex justify-center items-center mx-auto border border-gray-100 bg-gray-200 hover:border-gray-200 text-gray-700 text-3xl rounded-lg " id={"bnode_9ct7o" + (idx?"__"+idx:"")} model_id="fhmae" onClick={(e)=>{

            

            if(window.BROKEN_DEV_VARS && window.BROKEN_DEV_VARS.IS_EDITING_MODE) return;
            e.preventDefault(); e.stopPropagation(); 
            
            const el = e.currentTarget; el.disabled = true; el.classList?.add('disabled', 'cursor-progress');
                g_fn.bro_add_prop_item(e, INFO)
            el.disabled = false; el.classList?.remove('disabled', 'cursor-progress');
        }} extra-attr >
                
            <svg data_id="bnode_5kd26" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" id={"bnode_5kd26" + (idx?"__"+idx:"")} b_type="icon" extra-attr >
                
            <path data_id="" d="M5 12h14" extra-attr >
                
            </path>
        

            <path data_id="" d="M12 5v14" extra-attr >
                
            </path>
        
            </svg>
        
            </button>
        
            </div>) }

            <div data_id="bnode_48jzn" name="CONT-correct answers" className="w-full flex flex-col gap-2" id={"bnode_48jzn" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_qtdd9" className="block text-gray-700 text-sm font-medium mb-2 capitalize" id={"bnode_qtdd9" + (idx?"__"+idx:"")} extra-attr >
                correct answers
            </div>
        

                    {M && g_fn.safe_array(M.correct_answers).map(
                        (V, idx)=> (
                            
            <div data_id="bnode_yo35h" name="correct_answers" className="flex flex-col  w-full gap-6 " id={"bnode_yo35h" + (idx?"__"+idx:"")} key={g_fn.get_key_from_meta(M, "correct_answers", idx)} extra-attr >
                
            <div data_id="bnode_e0rit" name="cont" className="flex flex-row items-center justify-center w-full gap-4" id={"bnode_e0rit" + (idx?"__"+idx:"")} extra-attr >
                <input data_id="bnode_jnyx1" name="correct_answers" b_idx={idx} type="text" value={V.v} placeholder="correct_answers" action="oninput-update-m-idx" className="border border-[--neutral-100] hover:border-[--neutral-50] bg-[--shades-800] px-4 py-1.5 rounded focus:border-[var(--primary-400)] focus:border-1 focus:bg-white focus:outline-none w-full text-sm placeholder:text-sm placeholder:capitalize placeholder:text-[#222222]/30 " id={"bnode_jnyx1" + (idx?"__"+idx:"")} model_id="fhmae" onInput={(e)=>{g_fn.bro_on_input_idx(e, INFO)}} extra-attr />

            <button data_id="bnode_n76b0" name="correct_answers" b_idx={idx} action="delete-prop-item" className="bg-none text-rose-300 p-1.5 rounded-md hover:bg-rose-400 hover:text-white transition-all ease-in-out duration-150" id={"bnode_n76b0" + (idx?"__"+idx:"")} model_id="fhmae" onClick={(e)=>{

            

            if(window.BROKEN_DEV_VARS && window.BROKEN_DEV_VARS.IS_EDITING_MODE) return;
            e.preventDefault(); e.stopPropagation(); 
            
            const el = e.currentTarget; el.disabled = true; el.classList?.add('disabled', 'cursor-progress');
                g_fn.bro_delete_prop_item(e, INFO)
            el.disabled = false; el.classList?.remove('disabled', 'cursor-progress');
        }} extra-attr >
                
            <svg data_id="bnode_rfk22" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" id={"bnode_rfk22" + (idx?"__"+idx:"")} b_type="icon" extra-attr >
                
            <path data_id="" d="M18 6 6 18" extra-attr >
                
            </path>
        

            <path data_id="" d="m6 6 12 12" extra-attr >
                
            </path>
        
            </svg>
        
            </button>
        
            </div>
        
            </div>
        
                        )
                    )}
                

            <button data_id="bnode_3blrd" type="text" action="add-prop-item" name="correct answers" className="w-10 h-10 flex justify-center items-center mx-auto border border-gray-100 bg-gray-200 hover:border-gray-200 text-gray-700 text-3xl rounded-lg " id={"bnode_3blrd" + (idx?"__"+idx:"")} model_id="fhmae" onClick={(e)=>{

            

            if(window.BROKEN_DEV_VARS && window.BROKEN_DEV_VARS.IS_EDITING_MODE) return;
            e.preventDefault(); e.stopPropagation(); 
            
            const el = e.currentTarget; el.disabled = true; el.classList?.add('disabled', 'cursor-progress');
                g_fn.bro_add_prop_item(e, INFO)
            el.disabled = false; el.classList?.remove('disabled', 'cursor-progress');
        }} extra-attr >
                
            <svg data_id="bnode_ry697" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" id={"bnode_ry697" + (idx?"__"+idx:"")} b_type="icon" extra-attr >
                
            <path data_id="" d="M5 12h14" extra-attr >
                
            </path>
        

            <path data_id="" d="M12 5v14" extra-attr >
                
            </path>
        
            </svg>
        
            </button>
        
            </div>
        

            <div data_id="bnode_csyrs" name="CONT-answer explanation" className="w-full" id={"bnode_csyrs" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_bd7t8" id={"bnode_bd7t8" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_oyore" className="block text-black mb-2 capitalize text-base font-semibold font-['Open_Sans']" id={"bnode_oyore" + (idx?"__"+idx:"")} extra-attr >
                answer explanation
            </div>
        

            <div data_id="bnode_gp4ea" name="answer_explanation" className="flex flex-col  w-full gap-6 " id={"bnode_gp4ea" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_a0ve1" name="cont" className="flex-row w-full gap-4 flex justify-start items-center" id={"bnode_a0ve1" + (idx?"__"+idx:"")} extra-attr >
                
            <textarea data_id="bnode_xgypd" name="answer_explanation" placeholder="answer_explanation" value={M.answer_explanation} action="oninput-update-m" className="w-1/3 border border-[#9CA3AF] bg-white p-5 rounded-[12px] text-sm placeholder:text-sm placeholder:capitalize placeholder:text-[#222222]/30" id={"bnode_xgypd" + (idx?"__"+idx:"")} model_id="fhmae" onInput={(e)=>{g_fn.bro_on_input(e, INFO)}} extra-attr >
                
            </textarea>
        
            </div>
        
            </div>
        
            </div>
        
            </div>
        

            <div data_id="bnode_ksiqy" name="CONT-answer explanation image" className="w-full" id={"bnode_ksiqy" + (idx?"__"+idx:"")} extra-attr >
                
            </div>
        
            </div>
        

            <div data_id="bnode_48pl0" className="flex-row flex justify-end items-end pt-5 gap-4" id={"bnode_48pl0" + (idx?"__"+idx:"")} extra-attr >
                
            <div data_id="bnode_nmvhd" className="bg-[#FF5994] hover:bg- text-white font-medium p-4 px-8 rounded-[8px] focus:outline-none w-fit text-lg" id={"bnode_nmvhd" + (idx?"__"+idx:"")} extra-attr >
                CANCEL
            </div>
        

            <button data_id="bnode_gyvxc" op="create_one" className="bg-[#F3F4F6] hover:bg- text-white font-medium p-4 px-8 rounded-[8px] focus:outline-none w-fit text-lg text-[#4B5563]" id={"bnode_gyvxc" + (idx?"__"+idx:"")} onClick={(e)=>{

            

            if(window.BROKEN_DEV_VARS && window.BROKEN_DEV_VARS.IS_EDITING_MODE) return;
            e.preventDefault(); e.stopPropagation(); 
            
            const el = e.currentTarget; el.disabled = true; el.classList?.add('disabled', 'cursor-progress');
                g_fn.bro_create_one(e, M, INFO, props)
            el.disabled = false; el.classList?.remove('disabled', 'cursor-progress');
        }} model_id="fhmae" extra-attr >
                SAVE
            </button>
        
            </div>
        
            </div>
        
				</ErrorBoundary>
			)
		}

		export default comp_bnode_ltmqc;